var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('SceneViewer',{ref:"viewer",staticClass:"viewer",class:{ 'editing': _vm.editing },attrs:{"doc":_vm.doc}}),_vm._v(" "),_c('ScenePanel',{staticClass:"panel",class:{ 'editing': _vm.editing },attrs:{"doc":_vm.doc},on:{"editing":function (v) { _vm.editing = v }}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-053d6052","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/scene-builder/SceneBuilder.vue
// module id = 631
// module chunks = 2